const __request = require(`@/lib/data-service/default/__request/`)

/**
 *国内城市搜索
 */
export default function getDomestic(val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/common/area/getInlandAreaChildListByParentIdResponse"
    pParameter.data = val
    pParameter.check_token = false
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
